/* @ts-self-types="./viggo.d.ts" */

import * as wasm from "./viggo_bg.wasm";
import { __wbg_set_wasm } from "./viggo_bg.js";
__wbg_set_wasm(wasm);
wasm.__wbindgen_start();
export {
    BBox, ModifierLayout, SvgIcon, SvgIconImportStatus, SvgImportMessageCode, SvgImportMessageKind, SvgImportParams, SvgModifyOptions, SvgOutputOptions, SvgPropertyTemplate, SvgSizingParams, SvgStylesheetMode, WidthMode, WidthModeParams, iconNameRequirements, parseStandard, svgsAsSprite, validateIconName
} from "./viggo_bg.js";
